import { CauseOfDeath, DonorGender, NeuroStatus } from '@/api/apis/case';

export const NEURO_STATUS_LABELS: Record<NeuroStatus, string> = {
  [NeuroStatus.BrainDead]: 'Brain Dead',
  [NeuroStatus.BrainIsNotDead]: 'Brain Is Not Dead',
  [NeuroStatus.PendingBrainDeathDeclaration]: 'Pending Brain Death Declaration',
};

export const CAUSE_OF_DEATH_LABELS: Record<CauseOfDeath, string> = {
  [CauseOfDeath.Anoxia]: 'Anoxia',
  [CauseOfDeath.Cerebrovascular]: 'Cerebrovascular',
  [CauseOfDeath.HeadTrauma]: 'Head Trauma',
  [CauseOfDeath.CNSTumor]: 'CNS Tumor',
  [CauseOfDeath.Other]: 'Other',
};

export const GENDER_LABELS: Record<DonorGender, string> = {
  [DonorGender.Male]: 'Male',
  [DonorGender.Female]: 'Female',
  [DonorGender.Other]: 'Other',
};
